import mobx, { observable, action } from 'mobx';

class CommonStore {

    toJS(obj) {
        
        return mobx.toJS(obj);
    }
}

export default new CommonStore();